// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/backgroundTrade.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Images/trading.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripeBand{
    width: 100%;
    height: 100%;
    margin: 0 auto;
}

.imagebgWrapper{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
}

.groupCurrBtn{
    overflow-x: auto;
}

.groupCurrBtn::-webkit-scrollbar {
   display: none;
}
.groupPayBtn{
    overflow-x: auto;
}

.groupPayBtn::-webkit-scrollbar {
   display: none;
}

.trading-bg{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 12px;
    margin: 0px 10px 33px;
}
.trade-button{
    background: #64ED80;
    border-radius: 9px;
    font-weight: 600;
    border: none;
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-button{
    color: white;
    background: #0084FF;
    border: none;
    border-radius: 50px;
    padding: 6px 20px;

}
.groupCurrBtn button:focus-visible {
    background-color: #3545EE;
    color: #FFFFFF;
}
.groupCurrBtn button:focus{
    background-color: #3545EE;
    color: #FFFFFF;
}
.groupPayBtn button:active{
    background-color: #3545EE;
    color: #FFFFFF;
}
.groupPayBtn button:focus{
    background-color: #3545EE;
    color: #FFFFFF;
}

@media screen and (max-width:720px) {
    .imagebgWrapper{
        background-position: top -21px right 44%;
        background-attachment: fixed;
    }

    .trde-crpt{
        margin-top: 2rem;
    }
}

.header-text {
    width: 45%;
}

@media screen and (max-width: 999px){
    .header-text {
        width: 77%;
    }
}

.card-img-top {
    width: 190px;
    height: 140px;
}

.card-img-top-1 {
    width: 170px;
    height: 140px;
}
.card-img-top-2 {
    width: 140px;
    height: 140px;
}

.text-justify {
    text-align: justify;
}`, "",{"version":3,"sources":["webpack://./src/otherPages/Home/Index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yDAAgE;IAChE,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;GACG,aAAa;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA;GACG,aAAa;AAChB;;AAEA;IACI,yDAAwD;IACxD,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;;AAErB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI;QACI,wCAAwC;QACxC,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".stripeBand{\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n}\n\n.imagebgWrapper{\n    background-image: url('../../assets/Images/backgroundTrade.png');\n    background-position: top;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.groupCurrBtn{\n    overflow-x: auto;\n}\n\n.groupCurrBtn::-webkit-scrollbar {\n   display: none;\n}\n.groupPayBtn{\n    overflow-x: auto;\n}\n\n.groupPayBtn::-webkit-scrollbar {\n   display: none;\n}\n\n.trading-bg{\n    background-image: url(\"../../assets/Images/trading.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 12px;\n    margin: 0px 10px 33px;\n}\n.trade-button{\n    background: #64ED80;\n    border-radius: 9px;\n    font-weight: 600;\n    border: none;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.card-button{\n    color: white;\n    background: #0084FF;\n    border: none;\n    border-radius: 50px;\n    padding: 6px 20px;\n\n}\n.groupCurrBtn button:focus-visible {\n    background-color: #3545EE;\n    color: #FFFFFF;\n}\n.groupCurrBtn button:focus{\n    background-color: #3545EE;\n    color: #FFFFFF;\n}\n.groupPayBtn button:active{\n    background-color: #3545EE;\n    color: #FFFFFF;\n}\n.groupPayBtn button:focus{\n    background-color: #3545EE;\n    color: #FFFFFF;\n}\n\n@media screen and (max-width:720px) {\n    .imagebgWrapper{\n        background-position: top -21px right 44%;\n        background-attachment: fixed;\n    }\n\n    .trde-crpt{\n        margin-top: 2rem;\n    }\n}\n\n.header-text {\n    width: 45%;\n}\n\n@media screen and (max-width: 999px){\n    .header-text {\n        width: 77%;\n    }\n}\n\n.card-img-top {\n    width: 190px;\n    height: 140px;\n}\n\n.card-img-top-1 {\n    width: 170px;\n    height: 140px;\n}\n.card-img-top-2 {\n    width: 140px;\n    height: 140px;\n}\n\n.text-justify {\n    text-align: justify;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
